import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { ExportToolList } from '../../exportTools/components/ExportToolList';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejExportToolListPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej ? (
        <AppWrapper
          appType={APP_TYPE.VYDEJ}
          menu={<VydejMenu />}
          resource='ExportTools'
          action='retrieve'
        >
          <ExportToolList />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejExportToolListPage;
